import { Clock } from "./Clock";
import { Name } from "./Name";
import { Score } from "./Score";
import { ScoresByQuarterMini } from "./ScoresByQuarterMini";
import { BugStat } from "./BugStat";
import { PlayerStats } from "./PlayerStats";
import { ScoresByQuarter } from "./ScoresByQuarter";
import { Formation } from "./Formation";
import { SOF_Formation } from "./SOF_Formation";
import { MatchFacts } from "./MatchFacts";
import { TeamCrawl } from "./TeamCrawl";
import { MatchIdent } from "./MatchIdent";
import { ScoreStream } from "./ScoreStream";
import { OpenerSlate } from "./OpenerSlate";
import { TechincalSlate } from "./TechnicalSlate";
import { Guest } from "./Guest";
import { VoiceOf } from "./VoiceOf";
import { AnalysisTags } from "./AnalysisTags";
import { SmartBar } from "./SmartBar";
import { FFSlate } from "./FFSlate";
import { CentrePass } from "./CentrePass";
import { Timeout } from "./Timeout";
import { MatchIdent_ComingUp } from "./MatchIdent_ComingUp";
import { Table } from "./Table";
import { CustomTable } from "./CustomTable";
import { AmexPromo } from "./AmexPromo";
import { AmexPromoAlt } from "./AmexPromo_Alt";

export default function graphics({
  animate,
  update,
  animateOff,
  triggerAnimation,
  clearPreview,
  preview,
}) {
  return [
    new Clock({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Name({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),

    new Score({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Score({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new ScoresByQuarter({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new ScoresByQuarterMini({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new BugStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new PlayerStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Formation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new SOF_Formation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new MatchFacts({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new TeamCrawl({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new MatchIdent({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new MatchIdent_ComingUp({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new ScoreStream({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new OpenerSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new TechincalSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Guest({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new SmartBar({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new FFSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new CentrePass({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Timeout({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Table({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new AnalysisTags({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new VoiceOf({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new CustomTable({
      preview,
      animate,  
      update,
      animateOff,
      triggerAnimation,
    }),
    new AmexPromo({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new AmexPromoAlt({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
  ];
}
